module.exports = __webpack_public_path__ + "static/media/mouth-pop.cf1c2de6.wav";